import { render, staticRenderFns } from "./WorkingBL.vue?vue&type=template&id=cb8854c0&scoped=true"
import script from "./WorkingBL.vue?vue&type=script&lang=js"
export * from "./WorkingBL.vue?vue&type=script&lang=js"
import style0 from "./WorkingBL.vue?vue&type=style&index=0&id=cb8854c0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb8854c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb8854c0')) {
      api.createRecord('cb8854c0', component.options)
    } else {
      api.reload('cb8854c0', component.options)
    }
    module.hot.accept("./WorkingBL.vue?vue&type=template&id=cb8854c0&scoped=true", function () {
      api.rerender('cb8854c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/WorkingBL.vue"
export default component.exports